import SimObjectives from './SimObjectives';

export default SimObjectives;
